export const nothingToSeeHereMessages = {
  en: {
    title: 'Nothing to see here',
  },
};
